export enum CounterMedium {
  ElectricityMeter = 0, //0 
  HeatMeter = 1, //1 
  ColdMeter = 2, //2
  WaterMeter = 3, //3
  GasMeter = 4, //4
  FuelMeter = 5, //5
  }